export const PRODUCT_NAME = 'The Running Professional Pack™'
export const PRICE = '$27'
export const TOTAL_VALUE = '$552'
export const SUPPORT_EMAIL = 'atenciónstockdigital@gmail.com'
export const CHECKOUT_URL =
  'https://the-run-coach-blueprint-the-ultimate-professional-systems-bundl.impultienda.ar/checkout'

export const mockupImage =
  'https://cdn.magicpatterns.com/uploads/k5EiAWuTP9qkmotPPPC58Z/ChatGPT_Image_21_sept_2026,_07_38_46_p.m..png'

export const featuredImage =
  'https://cdn.magicpatterns.com/uploads/4e8Cgt9Qw3XrRCMjeVWKGC/ChatGPT_Image_21_sept_2026,_07_56_42_p.m..png'

export type Pain = {
  title: string
  description: string
}

export const pains: Pain[] = [
  {
    title: 'Athlete Boredom',
    description: 'They feel like they aren’t learning anything new, session after session.',
  },
  {
    title: 'Low Authority',
    description:
      'If you can’t explain the why and the how of a drill, they won’t pay premium prices.',
  },
  {
    title: 'Stagnant Results',
    description:
      'Without a progressive exercise system, your runners hit a plateau and eventually quit.',
  },
]

export type Bonus = {
  title: string
  description: string
  value: string
  image: string
  featured?: boolean
  tagline?: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Track-Side Session Cards™',
    description:
      'Ready-to-use sessions for any runner, any level. Print once and coach from them all season.',
    value: '$47',
    image: 'https://cdn.magicpatterns.com/uploads/kRDPdbVFwKVBCjAryX6vwM/run_1.webp',
  },
  {
    title: '30-Day Technique Overhaul Plan™',
    description:
      'A day-by-day sequence to run stronger, improve form, build consistency and see real results.',
    value: '$97',
    image: 'https://cdn.magicpatterns.com/uploads/aRYSvdiK9rJSHpKPjcBG5u/run_2.webp',
  },
  {
    title: 'Coach Cue Scripts™',
    description:
      'Clear cues and better communication so every drill lands correctly the first time.',
    value: '$67',
    image: 'https://cdn.magicpatterns.com/uploads/baTS4JMWu4jq54ot64JXRz/run_3.webp',
  },
  {
    title: '+100 Running Workouts™',
    description:
      'Speed sessions, hill workouts, tempo runs, long runs, and recovery — every session written out, with reps, paces, and progressions. Open it, pick the workout, run the session.',
    value: '$97',
    image:
      'https://cdn.magicpatterns.com/uploads/4e8Cgt9Qw3XrRCMjeVWKGC/ChatGPT_Image_21_sept_2026,_07_56_42_p.m..png',
    featured: true,
    tagline: 'Exercises ready for you to teach',
  },
  {
    title: 'Runner Progress Tracker™',
    description:
      'Track training, measure improvement, keep athletes motivated and hitting their goals.',
    value: '$47',
    image: 'https://cdn.magicpatterns.com/uploads/dPpV3j91iypxVTKrmymBuD/run_5.webp',
  },
]

export type Testimonial = {
  quote: string
  name: string
  role: string
  location: string
  result: string
  photo: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'I used to spend 2 hours a week planning my group sessions. Now I open the PDF on my tablet 5 minutes before class. My athletes are seeing results faster than ever.',
    name: 'Mark J.',
    role: 'Certified Coach',
    location: 'London, UK',
    result: '40% increase in retention',
    photo: 'https://cdn.magicpatterns.com/uploads/w7m1pvV5wwG11GjHYv83SP/run_img_1.jpg',
  },
  {
    quote:
      'The Fix-My-Form Drill Finder alone is worth 10x the price. I haven’t had a single athlete sidelined with shin splints this season.',
    name: 'Sarah L.',
    role: 'Marathon Trainer',
    location: 'Miami, USA',
    result: 'Zero injuries in 90 days',
    photo: 'https://cdn.magicpatterns.com/uploads/26QPqEfs9SpbeXR9dLmF7Y/run_img_2.jpg',
  },
  {
    quote:
      'I downloaded everything in two minutes and printed the session cards the same night. No videos to sit through — just open it and coach.',
    name: 'Diego R.',
    role: 'Running Group Leader',
    location: 'Bogotá, Colombia',
    result: '5 hours saved every week',
    photo: 'https://cdn.magicpatterns.com/uploads/hjagomWgtjSCLqRQYrgg9A/run_img_3.jpg',
  },
  {
    quote:
      'I bought it as a runner, not a coach. The 30-Day Technique Overhaul fixed my overstriding and I finally beat my half marathon PB.',
    name: 'Tom W.',
    role: 'Amateur Marathoner',
    location: 'Buenos Aires, Argentina',
    result: '6 minutes off his half PB',
    photo: 'https://cdn.magicpatterns.com/uploads/tZ4oBoqKCeURQkL8cUc9X7/run_img_4.jpg',
  },
  {
    quote:
      'The Progress Tracker changed how my athletes see themselves. They come back every week because they can actually see the improvement.',
    name: 'Camila S.',
    role: 'PE Teacher & Coach',
    location: 'São Paulo, Brazil',
    result: '28 athletes still training',
    photo: 'https://cdn.magicpatterns.com/uploads/qMCmVZuyGES5EH6SbDDUSJ/run_img_5.jpg',
  },
]

export type StackItem = {
  label: string
  value: string
  isCore?: boolean
}

export const stack: StackItem[] = [
  { label: 'The Running Professional Pack (100+ drills)', value: '$197', isCore: true },
  { label: 'Bonus 1: Track-Side Session Cards™', value: '$47' },
  { label: 'Bonus 2: 30-Day Technique Overhaul Plan™', value: '$97' },
  { label: 'Bonus 3: Coach Cue Scripts™', value: '$67' },
  { label: 'Bonus 4: Fix-My-Form Drill Finder™', value: '$97' },
  { label: 'Bonus 5: Runner Progress Tracker™', value: '$47' },
]

export type Step = {
  step: string
  title: string
  description: string
}

export const afterPurchase: Step[] = [
  {
    step: '01',
    title: 'Instant email delivery',
    description:
      'The second your payment clears, your download links arrive in your inbox. No waiting, no shipping.',
  },
  {
    step: '02',
    title: 'Download the PDFs',
    description:
      'Six high-resolution PDF files. Save them to your phone, tablet, or laptop and keep them forever.',
  },
  {
    step: '03',
    title: 'Print or open track-side',
    description:
      'Print the session cards and trackers, or open the pack on your tablet five minutes before the session starts.',
  },
]

export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'What format is this? Video or PDF?',
    answer:
      'It is 100% PDF. No videos, no audio, no physical books. Six high-resolution PDF files you can read on any device or print at home — designed to be used on the track, not watched on a couch.',
  },
  {
    question: 'Do I receive anything physical in the mail?',
    answer:
      'No. Nothing is shipped. This is a digital download delivered by email seconds after checkout.',
  },
  {
    question: 'Is it only for elite coaches?',
    answer:
      'No. It is designed for PE teachers, running group leaders, and even advanced runners who want to start coaching others.',
  },
  {
    question: 'I already know a lot of drills. Why do I need this?',
    answer:
      'This isn’t just a list — it’s a system. It categorizes drills by Problem / Solution. Overstriding? Do these 3 drills.',
  },
  {
    question: 'What if I need help?',
    answer: `Write to ${SUPPORT_EMAIL} and our support team will get back to you.`,
  },
]
